export const hello = () => true;

export const checkEmptyMapping = objectFieldsMapping => {
  const unMappedIds = [];
  if (Array.isArray(objectFieldsMapping)) {
    objectFieldsMapping.forEach(schema => {
      const { mapping: { source_fields } = {}, revvFieldID } = schema;
      if (
        !revvFieldID ||
        !Array.isArray(source_fields) ||
        !(source_fields.length > 0)
      )
        unMappedIds.push(revvFieldID);
    });
  }
  return unMappedIds;
};

export const createRandomMappingID = () =>
  Math.random().toString(36).substring(2, 7);
